import Swiper, {Navigation} from 'swiper';

export function initSliderFilter() {
  let swiper;

  function sliderFilter() {
    const initCategoryGroup = document.querySelector('.js-filter__swiper-init-category-group') as HTMLDivElement;
    const modalFilterCategoryGroupInput = document.getElementById('modalFilterCategoryGroup') as HTMLInputElement;

    swiper = new Swiper('.js-filter__swiper', {
      modules: [Navigation],
      slidesPerView: 1,
      initialSlide: +initCategoryGroup?.getAttribute('data-init-category-group-index')!,
      loop: true,
      navigation: {
        nextEl: '.js-filter__swiper-button-next',
        prevEl: '.js-filter__swiper-button-prev',
      },
      mousewheel: true,
      keyboard: true,
    });

    swiper.on('slideChange', () => {
      const slideEl = swiper.slides[swiper.activeIndex] as HTMLElement;
      const filterGroupBtn = slideEl.querySelector('.vrs-documentshop__filter-category-group') as HTMLButtonElement;
      if (modalFilterCategoryGroupInput) {
        modalFilterCategoryGroupInput.value = <string>filterGroupBtn.dataset.filterCategoryGroup;
      }
    });
  }

  sliderFilter();
}
